import { render, staticRenderFns } from "./WalletSecondary.vue?vue&type=template&id=8ad9d8aa&scoped=true&"
import script from "./WalletSecondary.vue?vue&type=script&lang=ts&"
export * from "./WalletSecondary.vue?vue&type=script&lang=ts&"
import style0 from "./WalletSecondary.vue?vue&type=style&index=0&id=8ad9d8aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad9d8aa",
  null
  
)

export default component.exports